import BasicLoadable from "@ovrsea/ovrlib/components/Loadable/BasicLoadable";

export const LoadableCompleteIncidentInformationModal = BasicLoadable({
  loader: () => import("./CompleteIncidentInformationModal"),
  loading: null,
});
